// import React, { useState, useEffect } from 'react';
// import getSubmissionPackageValues from './submissionPackage.jsx'


// function UploadTerritoriesMultilanguage(props) {
 
//     const [countriesTranslations, setCountriesTranslations] = useState("");
//      const [territoryIds, setTerritoryIds] = useState("");
//     const [territoriesFromServer, setTerritoriesFromServer] = useState("");
   


//   const updateTerritory = async () => {
// // Create First Draft
//    const requestOptions = {
//     method: "PUT",
//     body: JSON.stringify({
//   "name": "Afghanistan",
//     "name_es": "Afghanistan",
//     "name_fr": "Afghanistan",
//     "name_zh":"afg",
//     "name_ar": "afg",
//     "name_ru": "afg",
//     "country": "AFG",
//     "region": 2
// }),
//       headers: {
//           "accept": "application/json",
//           'Content-Type': 'application/json; charset=UTF-8',
//           "Authorization": "Token 629a98fb7d43585bcb19bb6c9b0001c6eb6fae0c"
//           },
//      };
//    fetch(`https://fao-forestry-genetic-resources-ia2zcfbi6q-ew.a.run.app/accounts/territories/155/`, requestOptions)
//  .then((response) => console.log(response.json())).then((data) => console.log(data));
//     };
   
//   useEffect(() => {
  
//      const getListOfCountries = async () => {
//         const url = process.env.PUBLIC_URL + `/json/policies_responses_jan2025.json`;
//         const serverCountriesUrl = process.env.PUBLIC_URL + `/json/server_countries.json`;
       
//         try {
  
//           const response = await fetch(url);
//           const json = await response.json();


//           const secondResponse = await fetch(serverCountriesUrl);
//           const secondJson = await secondResponse.json();

//           const territoriesList = [json[75]]; 
    
//          console.log("terrirotires list")
//           console.log(territoriesList);   
 
//           territoriesList.forEach(async (terr, index) => {
 
//  // setCountry(secondJson.find((elem) => elem.country.iso3 === terr.ISO3).id);
// await updateTerritory();
// //  console.log("last request" + lastRequest);
// //  setTimeout(async function () { await sendDraft({
// //   "id": 1019,
// //   "territory": 136,
// //   "user": 16,
// //   "start_date": 1742342400,
// //   "last_saved_date": 1742422032,
// //   "stage": "1",
// //   "territory_complete": 0,
// //   "species_reported": 0
// // }, terr);
// //  }, 100);
 

// console.log("finish executing");
//    console.log(index);
//    });

// } catch (error) {
//     console.log("error", error);
    
// }}
// //submitDraft("ciao");
// //
// getListOfCountries();
// //setCountry("id");
// //sendDraft(21, 21);
// //getLastSubmission();
// }

// ,[]);

   


//     return (
//       <React.Fragment>
//        <div>load transations</div>
//       </React.Fragment>
//     );
//   }


  

//     export default UploadTerritoriesMultilanguage;